import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

/** Rough content hint for a placeholder widget. */
type SkeletonWidgetKind = 'map' | 'bars' | 'rows' | 'kpi';

/** Placeholder widget, sized in grid units like the real gridstack items. */
interface SkeletonWidget {
  kind: SkeletonWidgetKind;
  w: number;
  h: number;
  /** Relative bar heights (percent) for `bars` placeholders. */
  bars?: number[];
}

/**
 * Loading placeholder for an opened view (bookmark or topic): mirrors the
 * menu bar, the headline/year-control strip and the 12-column widget grid of
 * `AuthenticatedAtlasComponent`, so the loaded view fades in without a
 * layout jump.
 */
@Component({
  selector: 'app-atlas-grid-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './atlas-grid-skeleton.component.html',
  styleUrl: './atlas-grid-skeleton.component.scss',
})
export class AtlasGridSkeletonComponent {
  /** Guest views have no menu bar - the logo sits in the headline strip. */
  @Input() guestView = false;
  /** Renders only the widget grid, e.g. inside the report skeleton. */
  @Input() widgetsOnly = false;

  readonly widgets: SkeletonWidget[] = [
    { kind: 'map', w: 7, h: 2 },
    { kind: 'bars', w: 5, h: 2, bars: [55, 80, 40, 95, 65, 75, 50, 85] },
    { kind: 'kpi', w: 4, h: 1 },
    { kind: 'rows', w: 4, h: 1 },
    { kind: 'kpi', w: 4, h: 1 },
    { kind: 'bars', w: 6, h: 2, bars: [30, 45, 60, 50, 70, 85, 75, 90, 95] },
    { kind: 'rows', w: 6, h: 2 },
  ];

  /** Label widths (percent) of the table row placeholders. */
  readonly rows = [70, 55, 80, 60, 45];
}
